import * as Sentry from "@sentry/browser";

// THIS FILE IS NOT INCLUDED IN VENDOR (OR OTHER) FOLDER BECAUSE IT HAS ITS OWN GULP TASK
// THIS FILE WILL BE LOADED SEPARATELY SO WE CAN USE THE CROSSORIGIN ATTRIBUTE ON IT TO PREVENT CORS ERRORS
/* ---------------------------------------------------------------------------
SENTRY INIT
---------------------------------------------------------------------------- */
/* global Sentry */
/* global frontendVars */
const SentryPlugin = (function () {
  const _config = {
    release: null,
    dsn: "https://2cf2c8f57e4a4af0a3b48d61ef97830e@o405442.ingest.sentry.io/5271075",
    urls: {
      static: ["static.rorix.nl", "staging.static.sawiday.com", "static/skins"],
      develop: [
        "localhost",
        "local.sanitairwinkel.nl",
        "local.sawiday.be",
        "local.sawiday.fr",
      ],
      production: [
        "sanitairwinkel.nl",
        "sawiday.be",
        "sawiday.fr",
        "sawiday.de",
        "sawiday.nl",
      ],
      staging: [
        "staging.sanitairwinkel.nl",
        "staging.sawiday.be",
        "staging.sawiday.fr",
        "staging.sawiday.de",
        "staging.sawiday.nl",
      ],
    },
  };

  /*------------------------
    INIT
    -------------------------- */
  const _init = () => {
    // Run only on specific templates
    let isActiveOnTemplate = false;
    if (
      frontendVars.pageTemplate.includes("customer-service.tpl") ||
      frontendVars.pageTemplate.includes("home.tpl") ||
      frontendVars.pageTemplate.includes("customer.tpl") ||
      frontendVars.pageTemplate.includes("checkout.tpl") ||
      frontendVars.pageTemplate.includes("cart.tpl") ||
      frontendVars.pageTemplate.includes("compare.tpl") ||
      frontendVars.pageTemplate.includes("order/order-status/order-status.tpl")
    ) {
      isActiveOnTemplate = true;
    }
    // Do not run Sentry on local develop environment
    if (!_isDevelopEnv() && isActiveOnTemplate) {
      // init Sentry
      Sentry.init({
        dsn: _config.dsn,
        environment: _getEnvironmentTag(),
        release: _config.release,
        allowUrls: [
          ..._config.urls.static,
          ..._config.urls.develop,
          ..._config.urls.production,
          ..._config.urls.staging,
        ],
        ignoreErrors: ["ResizeObserver loop limit exceeded"],
      });

      // set siteViewTag based on siteViewId. Example result: 'SWNL'
      if (typeof frontendVars.siteviewId !== "undefined") {
        Sentry.setTag(
          "siteview",
          _getSiteViewTag(parseInt(frontendVars.siteviewId)),
        );
      }
      // set template tag
      if (typeof frontendVars.siteviewId !== "undefined") {
        Sentry.setTag("main-template", frontendVars.pageTemplate);
      }
    }
  };

  /*------------------------
    GET SITEVIEW TAG
    -------------------------- */
  // Return string tag based on id (number) input
  // possible output: 'Undefined' / 'SWNL' / 'SWBE' / 'SWFR'
  const _getSiteViewTag = (id) => {
    let siteViewTag = "Undefined";
    // check for ids
    if (id === 1) {
      siteViewTag = "SWNL";
    } else if (id === 2) {
      siteViewTag = "SWBE";
    } else if (id === 7) {
      siteViewTag = "SWFR";
    }
    // return string tag
    return siteViewTag;
  };

  /*------------------------
    GET ENVIRONMENT TAG
    -------------------------- */
  // Return string based on hostname
  // possible output: 'development' / 'production' / 'testing'
  const _getEnvironmentTag = () => {
    let environment = "";

    if (_isProductionEnv()) {
      environment = "production";
    } else if (_isStagingEnv()) {
      environment = "staging";
    } else if (_isTestEnv()) {
      environment = "testing";
    } else if (_isDevelopEnv()) {
      environment = "development";
    }

    // return string
    return environment;
  };

  /*------------------------
    IS PRODUCTION
    -------------------------- */
  const _isProductionEnv = () => {
    return _config.urls.production.includes(window.location.hostname);
  };

  /*------------------------
    IS TEST
    -------------------------- */
  const _isTestEnv = () => {
    return window.location.href.indexOf("testomgeving") > -1;
  };

  /*------------------------
    IS STAGING
    -------------------------- */
  const _isStagingEnv = () => {
    return _config.urls.staging.includes(window.location.hostname);
  };

  /*------------------------
    IS DEVELOP
    -------------------------- */
  const _isDevelopEnv = () => {
    return _config.urls.develop.includes(window.location.hostname);
  };

  /*-----------------------------PUBLIC METHODS------------------------------*/
  return {
    init: _init,
  };
})();

//Initiate Sentry plugin
SentryPlugin.init();
